import React, { useMemo, useState } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Paper } from '@mui/material';
import Edit2LineIcon from 'remixicon-react/Edit2LineIcon';
import IconButton from '@mui/material/IconButton';
import MoreFillIcon from 'remixicon-react/MoreFillIcon';
import SelectMenu from 'components/common/menu/SelectMenu';
import { UserType } from 'hooks/useUserData';
import FlagLineIcon from 'remixicon-react/FlagLineIcon';
import useReportModalStore from 'store/useReportModalStore';
import EditProfileModal from '../EditProfile/EditProfileModal';
import ProfileAvatar from './ProfileAvatar';
import ProfileMetaInfo from './ProfileMetaInfo';

type ProfileDetailsProps = {
  user: UserType;
  isLoggedInUser: boolean;
};

const ProfileDetails: React.FC<ProfileDetailsProps> = ({ user, isLoggedInUser }) => {
  const theme = useTheme();
  const openReport = useReportModalStore((state) => state.openReport);
  const [openEditProfile, setOpenEditProfile] = useState(false);
  const menu = useMemo(
    () => [
      {
        title: 'Report',
        icon: <FlagLineIcon size={17} />,
        onClick: () =>
          openReport({
            id: user.id,
            text: user.username,
            reportObject: 'User',
          }),
      },
    ],
    [user],
  );

  return (
    <ProfileDetailsContainer>
      <Box display="flex" justifyContent="space-between">
        <Box display="flex">
          <Box mr={3}>
            <ProfileAvatar user={user} isLoggedInUser={isLoggedInUser} />
          </Box>
          <Box flex={1}>
            <ProfileMetaInfo user={user} />
          </Box>
        </Box>
        <Box>
          {isLoggedInUser ? (
            // <Link to={EDIT_PROFILE} state={{ user }}>
            //   <IconButton title="Edit" sx={{ mt: -1 }}>
            //     <Edit2LineIcon color={theme.palette.custom.lightBlack} />
            //   </IconButton>
            // </Link>
            <IconButton onClick={() => setOpenEditProfile(true)} title="Edit" sx={{ mt: -1 }}>
              <Edit2LineIcon color={theme.palette.custom.lightBlack} />
            </IconButton>
          ) : (
            <SelectMenu menu={menu}>
              <IconButton title="More Actions" sx={{ mt: -1 }}>
                <MoreFillIcon color={theme.palette.custom.lightBlack} />
              </IconButton>
            </SelectMenu>
          )}
        </Box>
      </Box>

      {openEditProfile && (
        <EditProfileModal open={openEditProfile} setOpen={setOpenEditProfile} user={user} />
      )}
    </ProfileDetailsContainer>
  );
};

const ProfileDetailsContainer = styled(Paper, { label: 'ProfileDetailsContainer' })(
  ({ theme }) => ({
    position: 'relative',
    width: '100%',
    minHeight: 150,
    backgroundColor: theme.palette.custom.white,
    padding: 24,
    borderRadius: 8,
    boxShadow: `0 4px 24px ${theme.palette.custom.boxShadow}`,
    marginBottom: 16,
  }),
);

export default ProfileDetails;
